module.exports = __webpack_public_path__ + "static/media/SK2.2f8d4d93.jpg";